module.exports = __webpack_public_path__ + "img/sfs-logo.4ebcd10c.jpg";